module.exports = __webpack_public_path__ + "media/images/pc/shop/step-03-f15bbc6f8efbe7e2cd6f360ce833d440.png";